<template>
  <div class="menu-list">
    <div class="menu-group" v-for="(menu, index) in localMenus" :key="index">
      <div class="menu-title" @click="toggleMenu(index)">
        <i :class="['menu-icon', menu.icon]"></i>
        {{ menu.title }}
        <i :class="['arrow', menu.expanded ? 'down' : 'right']"></i>
      </div>
      <div v-show="menu.expanded" class="submenu-group">
        <template v-for="(submenu, subIndex) in menu.children">
          <div
            :key="subIndex"
            class="submenu-item"
            @click="toggleSubMenu(submenu)"
          >
            <i :class="['submenu-icon', submenu.icon]"></i>
            {{ submenu.title }}
            <span v-if="submenu.title === '课程管理'" class="new-tag">new</span>
            <i
              v-if="submenu.children"
              :class="['arrow', submenu.expanded ? 'down' : 'right']"
            ></i>
          </div>

          <div
            v-if="submenu.children && submenu.expanded"
            :key="'third-' + subIndex"
            class="thirdmenu-group"
          >
            <div
              v-for="(thirdmenu, thirdIndex) in submenu.children"
              :key="thirdIndex"
              class="thirdmenu-item"
              @click="selectMenu(menu, submenu, thirdmenu)"
            >
              <i :class="['thirdmenu-icon', thirdmenu.icon]"></i>
              {{ thirdmenu.title }}
              <span v-if="thirdmenu.title === '考核管理'" class="new-tag"
                >new</span
              >
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SideMenu",
  props: {
    menus: [],
  },
  data() {
    return {
      localMenus: this.menus,
      currentView: "",
      currentMenu: {},
      currentSubMenu: {},
      currentThirdMenu: null,
    };
  },
  methods: {
    toggleMenu(index) {
      this.localMenus[index].expanded = !this.localMenus[index].expanded;
    },
    toggleSubMenu(submenu) {
      if (submenu.children) {
        submenu.expanded = !submenu.expanded;
        if (submenu.title === "绩效管理" || submenu.title === "绩效分析") {
          console.log("🚀 特殊处理：绩效管理/绩效分析按钮被点击");
        }
      } else {
        this.selectMenu(null, submenu);
      }
    },
    selectMenu(menu, submenu, thirdmenu = null) {
      this.currentMenu = menu || {};
      this.currentSubMenu = submenu;
      this.currentThirdMenu = thirdmenu;
      this.currentView = thirdmenu ? thirdmenu.component : submenu.component;
      if (thirdmenu) {
        // 处理三级菜单点击
        this.currentView = thirdmenu.component;
        if (thirdmenu.title === "考核规则") {
          this.$router.push({ name: "AssessmentRule" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        } else if (thirdmenu.title === "管理关键指标") {
          this.$router.push({ name: "CategoryManage" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        } else if (thirdmenu.title === "固定考核规则管理") {
          this.$router.push({ name: "FixedDimensionManage" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        } else if (thirdmenu.title === "考核管理") {
          this.$router.push({ name: "AssessmentTemplate" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        } else if (thirdmenu.title === "我的绩效") {
          this.$router.push({ name: "AssessmentRecord" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        } else if (thirdmenu.title === "绩效档案") {
          this.$router.push({ name: "PersonalPerformance" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        } else if (thirdmenu.title === "员工分析") {
          this.$router.push({ name: "DepartmentPerformance" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        } else if (thirdmenu.title === "部门绩效") {
          this.$router.push({ name: "DepartmentPerformancePage" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        }
      }
      // 设置当前视图
      if (submenu.title === "花名册") {
        this.currentView = "EmployeeList";
        console.log(this.$route);
        this.$router.push({ name: "EmployeeList" }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      } else {
        this.currentView = thirdmenu ? thirdmenu.component : submenu.component;
      }
      // 设置当前视图
      if (submenu.title === "档案分析") {
        this.currentView = "StaffStatistics";
        console.log(this.$route);
        this.$router.push({ name: "StaffStatistics" }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      } else {
        this.currentView = thirdmenu ? thirdmenu.component : submenu.component;
      }
      if (submenu.title === "课程管理") {
        this.currentView = "CourseManager";
        console.log(this.$route);
        this.$router.push({ name: "CourseManager" }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      } else {
        this.currentView = thirdmenu ? thirdmenu.component : submenu.component;
      }
      if (submenu.title === "学习记录") {
        this.currentView = "LearningRecord";
        console.log(this.$route);
        this.$router.push({ name: "LearningRecord" }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      } else {
        this.currentView = thirdmenu ? thirdmenu.component : submenu.component;
      }
      if (submenu.title === "我的培训") {
        this.currentView = "MyTraining";
        console.log(this.$route);
        this.$router.push({ name: "MyTraining" }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      } else {
        this.currentView = thirdmenu ? thirdmenu.component : submenu.component;
      }
    },
  },
};
</script>

<style scoped>
.menu-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
}

.menu-group {
  margin-bottom: 5px;
}

.menu-title {
  padding: 12px 20px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.menu-title:hover {
  background-color: #f5f7fa;
}

.menu-icon {
  margin-right: 10px;
  font-size: 16px;
  color: #409eff;
}

.arrow {
  border: solid #333;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  margin-left: auto;
  transition: transform 0.3s;
}

.arrow.right {
  transform: rotate(-45deg);
}

.arrow.down {
  transform: rotate(45deg);
}

.submenu-group {
  background-color: #fafafa;
}

.submenu-item {
  padding: 10px 20px 10px 35px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.submenu-item:hover {
  background-color: #f0f7ff;
}

.submenu-icon {
  margin-right: 8px;
  font-size: 14px;
  color: #67c23a;
}

.thirdmenu-group {
  background-color: #f5f5f5;
}

.thirdmenu-item {
  padding: 8px 20px 8px 50px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.thirdmenu-item:hover {
  background-color: #ebf5ff;
}

.thirdmenu-icon {
  margin-right: 8px;
  font-size: 14px;
  color: #e6a23c;
}

.content {
  flex: 1;
  overflow-y: auto;
}

.new-tag {
  display: inline-block;
  margin-left: 8px;
  padding: 0 5px;
  font-size: 12px;
  line-height: 16px;
  color: #fff;
  background-color: #f56c6c;
  border-radius: 10px;
  transform: scale(0.8);
}
</style>
